import React from 'react';
import PasswordStrength from 'ui/PasswordStrength';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const getServerSideErrorMessage = error => {
    if (typeof error === 'string') {
        return error;
    } else {
        return error && error.serverSide && error.message;
    }
};

const PasswordField = props => (
    <div style={{ marginBottom: props.noMargin ? 0 : 32 }}>
        <TextField
            type={props.visible ? 'text' : 'password'}
            fullWidth
            required={true}
            margin="normal"
            variant="outlined"
            {...props}
            onChange={event => props.onChange(event.target.value, event)}
            helperText={props.helper || getServerSideErrorMessage(props.error)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={() =>
                                props.onChangeVisible(props.visibleKey)
                            }
                        >
                            {props.visible ? (
                                <VisibilityOff color="primary" />
                            ) : (
                                <Visibility color="primary" />
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    </div>
);

const PasswordForm = ({
    errors,
    values,
    visible,
    onChange,
    onChangeVisible,
}) => {
    return (
        <>
            <PasswordField
                label="Current Password"
                error={errors.current_password}
                value={values.current_password || ''}
                onChange={onChange('current_password')}
                onChangeVisible={onChangeVisible}
                visible={visible.current_password}
                visibleKey="current_password"
            />
            <PasswordField
                label="New Password"
                error={errors.new_password}
                value={values.new_password || ''}
                onChange={onChange('new_password')}
                onChangeVisible={onChangeVisible}
                visible={visible.new_password}
                visibleKey="new_password"
                noMargin
            />
            <PasswordStrength
                visible={!!values.new_password}
                score={values.passwordScore}
            />
            <PasswordField
                label="Confirm New Password"
                error={errors.confirm_new_password}
                value={values.confirm_new_password || ''}
                onChange={onChange('confirm_new_password')}
                onChangeVisible={onChangeVisible}
                visible={visible.new_password}
                visibleKey="new_password"
            />
        </>
    );
};

export { PasswordForm };
